(() => {
  const selector = document.querySelector('[js-more-shirts-selector]');
  const popup = document.querySelector('[js-shirt-pdp-popup]');
  if (!selector || !popup) return;

  const track = selector.querySelector('[js-more-shirts-track]');
  const prevBtn = selector.querySelector('[js-more-shirts-prev]');
  const nextBtn = selector.querySelector('[js-more-shirts-next]');
  const body = popup.querySelector('[js-shirt-pdp-popup-body]');
  const closeBtns = popup.querySelectorAll('[js-shirt-pdp-close]');


    const updateHeaderZIndex = (isOpen) => {
    const headerStickies = document.querySelectorAll(
      '.template--bridal.collection_header_transparent_new .shopify-section-header-sticky, .shopify-section-header-sticky'
    );
    headerStickies.forEach((header) => {
      if (isOpen) {
        header.style.setProperty('z-index', '1', 'important');
      } else {
        header.style.removeProperty('z-index');
      }
    });
  };


  const openPopup = () => {
    popup.classList.add('popup-open');
    document.body.classList.add('popup-active');
    updateHeaderZIndex(true);
  };

  const closePopup = () => {
    popup.classList.remove('popup-open', 'is-loading');
    document.body.classList.remove('popup-active');
    updateHeaderZIndex(false);
  };

  const updateNav = () => {
    if (!track || !prevBtn || !nextBtn) return;
    const maxScroll = track.scrollWidth - track.clientWidth - 4;
    const canScroll = maxScroll > 0;
    prevBtn.hidden = !canScroll;
    nextBtn.hidden = !canScroll;
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  };

  const scrollByCard = (direction) => {
    const card = track.querySelector('.more-shirts-selector__item');
    const amount = card ? card.getBoundingClientRect().width + 10 : 100;
    track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  };

  const initAccordion = (root) => {
    root.querySelectorAll('[js-shirt-accordion-header]').forEach((header) => {
      header.addEventListener('click', () => {
        const item = header.closest('.js-accordion-item');
        const isOpen = item.classList.contains('active');
        root.querySelectorAll('.js-accordion-item').forEach((el) => {
          el.classList.remove('active');
          const panel = el.querySelector('[js-shirt-accordion-body]');
          if (panel) panel.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('active');
          const panel = item.querySelector('[js-shirt-accordion-body]');
          if (panel) panel.hidden = false;
        }
      });
    });

    root.querySelectorAll('[js-shirt-product-desc]').forEach((wrap) => {
      const shortDes = wrap.querySelector('.short_des');
      const longDes = wrap.querySelector('.long_des');
      if (!shortDes || !longDes) return;
      wrap.querySelectorAll('.desc_more').forEach((btn) => {
        btn.addEventListener('click', () => {
          const showLong = btn.closest('.short_des');
          shortDes.hidden = Boolean(showLong);
          longDes.hidden = !showLong;
          if (showLong) longDes.removeAttribute('style');
        });
      });
    });
  };

  const addBusinessDays = (numDaysToAdd) => {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = parseInt(numDaysToAdd, 10) || 0;
    const date = new Date();
    while (daysRemaining > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== Sunday && date.getDay() !== Saturday) {
        daysRemaining--;
      }
    }
    return date;
  };

  const addExpressDays = (numDaysToAdd) => {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = parseInt(numDaysToAdd, 10) || 0;
    const date = new Date();
    let firstWeekendSkipped = false;
    while (daysRemaining > 0) {
      const day = date.getDay();
      if (!firstWeekendSkipped && (day === Saturday || day === Sunday)) {
        date.setDate(date.getDate() + 1);
        if (day === Sunday) {
          firstWeekendSkipped = true;
        }
        continue;
      }
      daysRemaining--;
      date.setDate(date.getDate() + 1);
    }
    while (!firstWeekendSkipped && (date.getDay() === Saturday || date.getDay() === Sunday)) {
      if (date.getDay() === Sunday) firstWeekendSkipped = true;
      date.setDate(date.getDate() + 1);
    }
    return date;
  };

  const formatDeliveryDate = (date) => {
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    return `${weekdays[date.getDay()]}, ${day} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const formatDeliveryDateRange = (startDate) => {
    const endDate = new Date(startDate.getTime());
    endDate.setDate(endDate.getDate() + 3);
    return `${formatDeliveryDate(startDate)} - ${formatDeliveryDate(endDate)}`;
  };

  const setShirtDelivery = (root, days, deliveryType = 'RTS', quantity = 1) => {
    const deliveryWrap = root.querySelector('[js-shirt-delivery-wrapper]');
    const internationalExtraDays = parseInt(deliveryWrap?.dataset?.internationalExtraDays || '0', 10) || 0;
    const parsedDays = parseInt(days, 10) || 0;
    const totalDays = parsedDays + internationalExtraDays;
    const isMto = deliveryType === 'MTO' || quantity < 1;

    let calculatedDate;
    if (isMto) {
      calculatedDate = addBusinessDays(totalDays);
    } else {
      calculatedDate = addExpressDays(totalDays);
    }
    const formattedDate = formatDeliveryDateRange(calculatedDate);

    const deliveryEl = root.querySelector('[js-shirt-delivery-time]');
    if (deliveryEl) deliveryEl.textContent = formattedDate;

    const form = root.querySelector('[js-shirt-atc-form], form[data-type="add-to-cart-form"]');
    if (form) {
      form.setAttribute('data-delivery-current-delivery-day-value', days);

      const daysInput = form.querySelector('[js-shirt-delivery-days-input]');
      if (daysInput) daysInput.value = days;
      

      const dtInput = form.querySelector('[js-shirt-delivery-type-input]');
      if (dtInput) dtInput.value = isMto ? 'MTO' : 'RTS';

      let expressInput = form.querySelector('[js-shirt-estimated-express-delivery-input]');
      let standardInput = form.querySelector('[js-shirt-estimated-delivery-input]');

      if (isMto) {
        if (expressInput) expressInput.remove();
        if (!standardInput) {
          standardInput = document.createElement('input');
          standardInput.type = 'hidden';
          standardInput.name = 'items[0][properties][Estimated delivery]';
          standardInput.setAttribute('js-shirt-estimated-delivery-input', '');
          form.appendChild(standardInput);
        }
        standardInput.value = formattedDate;

        const expressAttr = form.querySelector('[express_delivery_cart_attributes]');
        if (expressAttr) expressAttr.remove();
      } else {
        if (standardInput) standardInput.remove();
        if (!expressInput) {
          expressInput = document.createElement('input');
          expressInput.type = 'hidden';
          expressInput.name = 'items[0][properties][Priority express shipping]';
          expressInput.setAttribute('js-shirt-estimated-express-delivery-input', '');
          form.appendChild(expressInput);
        }
        expressInput.value = formattedDate;

        let expressAttr = form.querySelector('[express_delivery_cart_attributes]');
        if (!expressAttr) {
          expressAttr = document.createElement('input');
          expressAttr.type = 'hidden';
          expressAttr.setAttribute('express_delivery_cart_attributes', '');
          expressAttr.name = 'attributes[Express Delivery]';
          expressAttr.value = 'Express Delivery';
          form.appendChild(expressAttr);
        }
      }
    }

    const mtoMsgEl = root.querySelector('[js-shirt-mto-message]');
    if (mtoMsgEl) {
      if (isMto) {
        mtoMsgEl.innerHTML = `This size is sold out and will be made to order for you.<br> Est. Delivery by ${formattedDate}`;
        mtoMsgEl.classList.remove('hidden');
      } else {
        mtoMsgEl.innerHTML = '';
        mtoMsgEl.classList.add('hidden');
      }
    }

    const labelEl = root.querySelector('[js-shirt-delivery-label]');
    if (labelEl) {
      labelEl.textContent = isMto ? 'Estimated delivery :' : 'Priority express shipping :';
    }

    const expressIcon = root.querySelector('.shirt-icon-express');
    const standardIcon = root.querySelector('.shirt-icon-standard');
    if (expressIcon) {
      expressIcon.style.display = isMto ? 'none' : 'inline-block';
    }
    if (standardIcon) {
      standardIcon.style.display = isMto ? 'inline-block' : 'none';
    }
  };

  const setShirtPrice = (root, input) => {
    if (!input) return;
    const formattedPrice = input.dataset.variantPrice;
    const formattedCompare = input.dataset.variantCompare;
    const discountLabel = input.dataset.discountLabel;
    const rawPrice = parseInt(input.dataset.variantRawPrice || '0', 10);
    const rawCompare = parseInt(input.dataset.variantRawCompare || '0', 10);
    const isOnSale = rawCompare > rawPrice && Boolean(formattedCompare);

    if (formattedPrice) {
      const atcPrice = root.querySelector('[js-shirt-atc-price], [js-pdp-original-price]');
      if (atcPrice) atcPrice.textContent = formattedPrice;
    }

    const priceRoot = root.querySelector('[js-shirt-price]');
    if (!priceRoot) return;

    const priceContainer = priceRoot.querySelector('.price');
    if (priceContainer) {
      if (isOnSale) {
        priceContainer.classList.add('price--on-sale');
      } else {
        priceContainer.classList.remove('price--on-sale');
      }
    }

    const regularPriceEl = priceRoot.querySelector('.price__regular .price-item--regular');
    if (regularPriceEl && formattedPrice) {
      regularPriceEl.innerHTML = `<span class="price-mrp">MRP</span> ${formattedPrice}`;
      regularPriceEl.setAttribute('data-pdp-product-price', formattedPrice.replace(/[^\d.,]/g, ''));
    }

    const comparePriceEl = priceRoot.querySelector('.price__sale .price-item--regular s');
    if (comparePriceEl && formattedCompare) {
      comparePriceEl.textContent = formattedCompare;
    }

    const salePriceEl = priceRoot.querySelector('.price__sale .price-item--last');
    if (salePriceEl && formattedPrice) {
      salePriceEl.innerHTML = `<span class="price-mrp">MRP</span> ${formattedPrice}`;
      salePriceEl.setAttribute('data-pdp-product-price', formattedPrice.replace(/[^\d.,]/g, ''));
    }

    const discountBadge = priceRoot.querySelector('.price__badge-sale .badge');
    if (discountBadge) {
      if (isOnSale && discountLabel) {
        discountBadge.textContent = discountLabel;
        discountBadge.classList.remove('hide');
      } else {
        discountBadge.classList.add('hide');
      }
    }

    const styleNoEl = root.querySelector('[js-shirt-style-no]');
    if (styleNoEl && input.dataset.variantStyleNo) {
      styleNoEl.textContent = `Style No ${input.dataset.variantStyleNo}`;
    }
  };

  const setShirtReturnable = (root, input) => {
    if (!input) return;
    const isReturnable = input.dataset.returnable;
    const returnableInput = root.querySelector('[js-shirt-returnable-input]');
    if (returnableInput) {
      if (isReturnable === 'false') {
        returnableInput.value = 'False';
      } else if (isReturnable === 'true') {
        returnableInput.value = 'True';
      }
    }

    const detailsWrap = root.querySelector('[js-shirt-product-details]');
    const regularText = root.querySelector('.image-logo-no-return .regular-text');
    const noneText = root.querySelector('.image-logo-no-return .return-text-none');
    if (isReturnable === 'false') {
      if (detailsWrap) {
        detailsWrap.classList.remove('returnable-variant');
        detailsWrap.classList.add('non-returnable', 'non-returnable-variant');
      }
      if (regularText) regularText.classList.add('hide');
      if (noneText) noneText.classList.remove('hide');
    } else {
      if (detailsWrap) {
        detailsWrap.classList.remove('non-returnable', 'non-returnable-variant');
        detailsWrap.classList.add('returnable-variant');
      }
      if (regularText) regularText.classList.remove('hide');
      if (noneText) noneText.classList.add('hide');
    }
  };

  const initSizeChart = (root) => {
    const openBtn = root.querySelector('[js-shirt-size-guide-open]');
    const sizeChartModal = root.querySelector('.size-chart, .shirt-pdp-size-chart, [js-shirt-size-chart-popup], [js-pdp-size-chart-popup]');
    if (!openBtn || !sizeChartModal) return;

    const closeChart = () => {
      sizeChartModal.classList.add('hide');
      sizeChartModal.classList.remove('active');
      sizeChartModal.style.display = 'none';
    };

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      sizeChartModal.classList.remove('hide');
      sizeChartModal.classList.add('active');
      sizeChartModal.style.display = 'block';
    });

    const closeBtns = sizeChartModal.querySelectorAll('[js-shirt-size-chart-close], [js-popup-close-btn], .cross-icon, [js-close-size-chart], .size-chart__close');
    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeChart();
      });
    });

    sizeChartModal.addEventListener('click', (e) => {
      if (e.target === sizeChartModal) {
        closeChart();
      }
    });

    const inchBtn = sizeChartModal.querySelector('[js-size-convert-btn-inch]');
    const cmBtn = sizeChartModal.querySelector('[js-size-convert-btn-cm]');
    const inchImages = sizeChartModal.querySelectorAll('[data-parameter="in"]');
    const cmImages = sizeChartModal.querySelectorAll('[data-parameter="cm"]');

    if (inchBtn && cmBtn) {
      inchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        inchBtn.classList.add('active');
        cmBtn.classList.remove('active');
        inchImages.forEach((img) => img.classList.remove('visually-hide'));
        cmImages.forEach((img) => img.classList.add('visually-hide'));
      });

      cmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        cmBtn.classList.add('active');
        inchBtn.classList.remove('active');
        cmImages.forEach((img) => img.classList.remove('visually-hide'));
        inchImages.forEach((img) => img.classList.add('visually-hide'));
      });
    }
  };

  const initSizePicker = (root) => {
    const variantInput = root.querySelector('input.product-variant-id');
    const deliveryWrap = root.querySelector('[js-shirt-delivery-wrapper]');

    const checkedInput =
      root.querySelector('[js-shirt-size-input]:checked') ||
      root.querySelector('[js-shirt-size-input]:not([disabled])');
    if (checkedInput) {
      setShirtPrice(root, checkedInput);
      const deliveryDays = checkedInput.dataset.deliveryDays || deliveryWrap?.dataset?.defaultDays || 0;
      const deliveryType = checkedInput.dataset.deliveryType || deliveryWrap?.dataset?.defaultDeliveryType || 'RTS';
      const quantity = parseInt(checkedInput.dataset.variantQuantity || '0', 10);
      setShirtDelivery(root, deliveryDays, deliveryType, quantity);
      setShirtReturnable(root, checkedInput);
    } else if (deliveryWrap) {
      setShirtDelivery(root, deliveryWrap.dataset.defaultDays, deliveryWrap.dataset.defaultDeliveryType || 'RTS', 1);
    }

    root.querySelectorAll('[js-shirt-size-input]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        if (variantInput) variantInput.value = input.dataset.variantId;
        setShirtPrice(root, input);
        const deliveryDays = input.dataset.deliveryDays || deliveryWrap?.dataset?.defaultDays || 0;
        const deliveryType = input.dataset.deliveryType || 'RTS';
        const quantity = parseInt(input.dataset.variantQuantity || '0', 10);
        setShirtDelivery(root, deliveryDays, deliveryType, quantity);
        setShirtReturnable(root, input);
      });
    });
  };

  const initShirtForm = (root) => {
    const form = root.querySelector('[js-shirt-atc-form], form[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      const spinner = form.querySelector('.loading__spinner');
      const variantInput = form.querySelector('input.product-variant-id');
      const selectedSize = form.querySelector('[js-shirt-size-input]:checked');
      
      if (variantInput && variantInput.dataset.requiresSize && !selectedSize) {
        const errorWrap = form.querySelector('[js-pdp-form-error] ul');
        if (errorWrap) errorWrap.innerHTML = '<li>Please select size</li>';
        form.reportValidity();
        return;
      }

      if (selectedSize && variantInput) {
        variantInput.value = selectedSize.dataset.variantId;
        variantInput.removeAttribute('disabled');
      }

      const deliveryEl = root.querySelector('[js-shirt-delivery-time]');
      const deliveryDateText = deliveryEl ? deliveryEl.textContent.trim() : '';
      const deliveryType = selectedSize?.dataset?.deliveryType || form.querySelector('[js-shirt-delivery-type-input]')?.value || 'RTS';
      const quantity = parseInt(selectedSize?.dataset?.variantQuantity || '0', 10);
      const isMto = deliveryType === 'MTO' || quantity < 1;

      if (isMto) {
        let standardInput = form.querySelector('[js-shirt-estimated-delivery-input]');
        if (!standardInput) {
          standardInput = document.createElement('input');
          standardInput.type = 'hidden';
          standardInput.name = 'items[0][properties][Estimated delivery]';
          standardInput.setAttribute('js-shirt-estimated-delivery-input', '');
          form.appendChild(standardInput);
        }
        if (deliveryDateText) standardInput.value = deliveryDateText;
        const expressInput = form.querySelector('[js-shirt-estimated-express-delivery-input]');
        if (expressInput) expressInput.remove();
        const expressAttr = form.querySelector('[express_delivery_cart_attributes]');
        if (expressAttr) expressAttr.remove();
      } else {
        let expressInput = form.querySelector('[js-shirt-estimated-express-delivery-input]');
        if (!expressInput) {
          expressInput = document.createElement('input');
          expressInput.type = 'hidden';
          expressInput.name = 'items[0][properties][Priority express shipping]';
          expressInput.setAttribute('js-shirt-estimated-express-delivery-input', '');
          form.appendChild(expressInput);
        }
        if (deliveryDateText) expressInput.value = deliveryDateText;
        const standardInput = form.querySelector('[js-shirt-estimated-delivery-input]');
        if (standardInput) standardInput.remove();
        let expressAttr = form.querySelector('[express_delivery_cart_attributes]');
        if (!expressAttr) {
          expressAttr = document.createElement('input');
          expressAttr.type = 'hidden';
          expressAttr.setAttribute('express_delivery_cart_attributes', '');
          expressAttr.name = 'attributes[Express Delivery]';
          expressAttr.value = 'Express Delivery';
          form.appendChild(expressAttr);
        }
      }

      let deliveryTypeInput = form.querySelector('[js-shirt-delivery-type-input]');
      if (!deliveryTypeInput) {
        deliveryTypeInput = document.createElement('input');
        deliveryTypeInput.type = 'hidden';
        deliveryTypeInput.name = 'items[0][properties][_Delivery type]';
        deliveryTypeInput.setAttribute('js-shirt-delivery-type-input', '');
        form.appendChild(deliveryTypeInput);
      }
      deliveryTypeInput.value = isMto ? 'MTO' : 'RTS';

      const formData = new FormData(form);
      formData.set('items[0][id]', variantInput ? variantInput.value : formData.get('id'));
      formData.set('items[0][quantity]', '1');
      formData.set('items[0][properties][_Delivery type]', isMto ? 'MTO' : 'RTS');
      formData.delete('id');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const errorWrap = form.querySelector('[js-pdp-form-error] ul');
            if (errorWrap) {
              errorWrap.innerHTML = `<li>${response.description || response.message || 'Unable to add this shirt.'}</li>`;
            }
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          }
          closePopup();
        })
        .catch(() => {
          const errorWrap = form.querySelector('[js-pdp-form-error] ul');
          if (errorWrap) {
            errorWrap.innerHTML = '<li>Unable to add this shirt. Please try again.</li>';
          }
        })
        .finally(() => {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    });
  };

  const loadShirt = (item) => {
    const handle = item.dataset.shirtHandle;
    const sameAsModel = item.dataset.sameAsModel === 'true';
    const shirtUrl = item.dataset.shirtUrl;
    if (!handle && !shirtUrl) return;
    body.innerHTML = '';
    popup.classList.add('is-loading');
    openPopup();

    const url = shirtUrl
      ? `${shirtUrl}${shirtUrl.includes('?') ? '&' : '?'}view=shirt-pdp-popup`
      : `/products/${handle}?view=shirt-pdp-popup`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load shirt');
        return response.text();
      })
      .then((html) => {
        body.innerHTML = html;
        const stamp = body.querySelector('[js-same-as-model-stamp]');
        if (stamp) stamp.classList.toggle('is-visible', sameAsModel);
        initAccordion(body);
        initSizePicker(body);
        initSizeChart(body);
        initShirtForm(body);
        if (window.WishlistKing && typeof window.WishlistKing.observe === 'function') {
          try { window.WishlistKing.observe(); } catch(e) {}
        }
      })
      .catch((err) => {
        console.error('Error loading shirt popup:', err);
        body.innerHTML = '<p class="shirt-pdp-popup__error">Unable to load this shirt. Please try again.</p>';
      })
      .finally(() => {
        popup.classList.remove('is-loading');
      });
  };

  selector.querySelectorAll('[js-more-shirts-item]').forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      loadShirt(item);
    });
  });

  closeBtns.forEach((btn) => btn.addEventListener('click', closePopup));

  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('popup-open')) {
      closePopup();
    }
  });

  popup.addEventListener('shirt-pdp-popup:close', closePopup);

  if (prevBtn && nextBtn && track) {
    prevBtn.addEventListener('click', () => scrollByCard(-1));
    nextBtn.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }
})();
